<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M4.5 6a1.5 1.5 0 011.5-1.5h12a1.5 1.5 0 011.5 1.5v12a1.5 1.5 0 01-1.5 1.5h-12A1.5 1.5 0 014.5 18z"
    />
    <path stroke-linecap="round" stroke-linejoin="round" d="M7 10.5h10" />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 7.5l.67 1.41 1.58.2-1.17 1.12.28 1.57L12 10.75l-1.36.95.28-1.57-1.17-1.12 1.58-.2z"
    />
    <path stroke-linecap="round" stroke-linejoin="round" d="M8.5 14.5h.01M11.5 14.5h.01M14.5 14.5h.01" />
  </svg>
</template>
